const baseFields = require('./baseGameFields')

const fields = []

module.exports = {
  sanityTypeDef: {
    title: 'Arma III',
    name: 'arma',
    type: 'object',
    fields: [...baseFields, ...fields],
    preview: {
      select: {},
      prepare() {
        return { title: 'Arma III' }
      },
    },
  },
  fields,
}



// WEBPACK FOOTER //
// /opt/build/repo/sanity/schemas/games/armaInfo.js